import { useEffect } from 'react';
import { useScrollLock } from '../../../_Hooks/useScrollLock';
import { FaTimes } from 'react-icons/fa';
import { NavList } from './NavList';

const BLOCK = 'LStudio__app_header';

/*
    🔥 CONTENEDOR DE LA NAV COLAPSADA

    dropdown  -> panel bajo la barra (como el original en mobile)
    offcanvas -> cajón desde la derecha, con backdrop
    sidebar   -> cajón desde la izquierda, con backdrop

    No uso el Offcanvas de react-bootstrap a propósito: usa portal y el
    panel saldría del <header>, perdiendo el data-header que gobierna el CSS.
*/

export const NavPanel = ({ mode = 'dropdown', title = '', isOpen, onClose, items = [] }) => {

    const HAS_BACKDROP = mode === 'offcanvas' || mode === 'sidebar';

    /*
        🔥 Bloquea el scroll del body solo en los modos con backdrop.

        ⚠️ Lo hace el hook compartido, con contador: si además hay un
           modal abierto, el scroll se libera recién cuando se cierran
           los dos.
    */
    useScrollLock(isOpen && HAS_BACKDROP);

    return (
        <>
            {HAS_BACKDROP && isOpen && (
                <div className={`${BLOCK}__backdrop`} onClick={onClose} aria-hidden="true" />
            )}

            <div className={`${BLOCK}__panel`} data-mode={mode} data-open={isOpen}
                role={HAS_BACKDROP ? 'dialog' : undefined}
                aria-modal={HAS_BACKDROP ? true : undefined}
                aria-label={title} >

                {HAS_BACKDROP && (
                    <div className={`${BLOCK}__panel_head`}>
                        <span>{title}</span>
                        <button type="button" className={`${BLOCK}__panel_close`}
                            aria-label="Cerrar" onClick={onClose} >
                            <FaTimes />
                        </button>
                    </div>
                )}

                <div className={`${BLOCK}__panel_body`}>
                    <NavList items={items} isVertical onNavigate={onClose} />
                </div>

            </div>
        </>
    );
};
